import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import { setConfig } from '@creditas-lab/auth-sdk'
import { App } from './App'
import { getLogger } from '~/utils/logger'

if (process.env.NODE_ENV !== 'production') {
  setConfig('staging')
}

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent: () => {
    return new Promise(resolve => {
      resolve(App)
    })
  },
  errorBoundary(err, info, props) {
    getLogger().error(err, { info, props })
    throw err
  },
})

export const { bootstrap, mount, unmount } = lifecycles
